import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MessageToUiService } from 'src/app/services/message-to-ui.service';
import { CaseActionSentBy, IHistoryData } from 'src/app/shared/models';

@Component({
  selector: 'app-case-timeline',
  templateUrl: './case-timeline.component.html',
  styleUrls: ['./case-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MatTabsModule, MatTooltipModule]
})
export class CaseTimelineComponent {
  constructor(public dialog: MatDialog, private notificationService: MessageToUiService) {
  }

  @Input() list: IHistoryData[];
  @Output() documentRequested = new EventEmitter<{identifier : string, encode : boolean}>();
  @Output() smsRequested = new EventEmitter<IHistoryData>();

  @ViewChild('itemView') template: TemplateRef<any>;


  get itemsOfIterest(): IHistoryData[] {
    let now = new Date();
    const intervalStart = now.setMonth(now.getMonth() - 3);
    now = new Date();
    const intervalEnd = now.setMonth(now.getMonth() + 3);

    return this.list?.map(item => {
      item.date = new Date(item.date);
      item.sentBy = this.filterSentBy(item);
      item.tooltip = this.formatTooltip(item);
      item.isFutureLetterOrSms = !item.isExecuted && item.type != 'NA';
      item.canView = !item.isFutureLetterOrSms && item.dispayOnCustomerWeb;
      item.class = item.isSms ? 'icon-sms': (item.isLetter ? 'icon-letter': (item.isEmail ? 'icon-email' : ''));
      return item;
    })
      .filter(item => item.date
          && intervalStart <= item.date.getTime()
          && item.date.getTime() <= intervalEnd
          && (item.isFutureLetterOrSms || item.documentIdentifier?.length > 1))
      .sort((a, b) => new Date(a.date).getTime() < new Date(b.date).getTime() ? -1 : 1);
  }

  formatTooltip(item: IHistoryData): string {
    let tooltip = Intl.DateTimeFormat('no-NO').format(item.date).toString() + ' ' + item.text;
    if (item.sentBy != undefined) {
      tooltip += ` ` + `-> ` + item.sentBy;
    }
    return tooltip;
  }

  filterSentBy(item: IHistoryData): string {
    return item.sentById == CaseActionSentBy.JustExecuted ? '' : CaseActionSentBy[item.sentById];
  }

  view(item: IHistoryData): void {
    if (item.isFutureLetterOrSms) {
      this.notificationService.errorKey('Error.LetterNotProduced');
      return;
    }

    if (!item.canView) 
      return;

    if (item.type == 'SMS')
      return this.smsRequested.emit(item);
      
    if (item.type == 'EMAIL')
      return this.documentRequested.emit({identifier : item.documentIdentifier, encode : false});
    
    this.documentRequested.emit({identifier : item.documentIdentifier, encode : true});
  }

  viewAll() {
    this.dialog.open(this.template, {
      height: '50%',
      data: {
        executed: this.list?.filter(x => x.isExecuted),
        notExecuted: this.list?.filter(x => !x.isExecuted).reverse()
      }
    });
  }
}
